import { getAsyncTypes } from '../helpers/actionType';
import { authService } from '../services/authService'
import * as profileService from '../services/profileService'
import * as systemService from '../services/systemService'
import { showNotification, dispatchWithNotification } from '../redux/Notification'
import log from '../helpers/logger';
// action type
export const LOGIN = getAsyncTypes('AUTH_LOGIN');
export const LOGOUT = getAsyncTypes('AUTH_LOGOUT');
export const GET_TOKEN = getAsyncTypes('AUTH_GET_TOKEN');
export const GET_USER = getAsyncTypes('AUTH_GET_USER');
export const SESSION_TIMEOUT = getAsyncTypes('AUTH_LOGIN');
export const UPD_PROFILE = getAsyncTypes('AUTH_UPDATE_PROFILE');
export const CHANGE_PASSWORD = getAsyncTypes('AUTH_CHANGE_PASSWORD');
export const RESET_PASSWORD_EMAIL = getAsyncTypes('AUTH_RESET_PASSWORD_EMAIL');
export const SWITCH_CURRENT = getAsyncTypes('AUTH_SWITCH_CURRENT');

// reducer
const initState = {
    user: {},
    Label: {
        Login: "Log-in",
        Logout: "Logout",
        UserName: "User Name",
        Password: "Password",
        UserNameEmpty: "User Name cannot be empty",
        PasswordEmpty: "Password cannot be empty",
        LoginScreenTitle: "Login to Your Account",
        LoginScreenDesc: "Please enter your login details",
        Profile: "Profile",
        ProfileSubtitle: "Update your profile information",
        NewPassword: "New Password",
        NewPasswordSubtitle: "Change your password",
        NewLoginName: "Login Name",
        NewUserName: "Shown as",
        NewUserEmail: "Email",
        NewuserPassword: "New Password",
        ConfirmPwd: "Confirm Password",
        UpdProfileBtn: "Update",
        pdPwdBtn: "Change Password",
        NewUsrPasswordEmpty: "Please enter a new password",
        ConfirmPwdEmpty: "Please enter a matching password",
        PwdHlpMsgLabel:"Minimum 8 characters and at least one digit, one capital, one lower case and one symbol",
        ApplySettingsBtn: "Apply Settings",
        Settings: "Settings",
        SettingsSubtitle: "Select your settings",
        CompanyList: "Company",
        ProjectList: "Project",
        SystemsList: "System",
        TimeZoneList: "TimeZone",
        ResetLoginName: "User Name",
        ResetUsrEmail: "Email",
        ResetPwdBtn: "Reset",
        Or: "OR",
        ResetPwdTitle: "Reset Password",
        ResetPwdSubtitle: "Enter your username or email to reset password",
        Information: "Information",
        UnSavedPage: "You have not saved your changes. Are you sure you want to leave?",
    },
    filter: {
        CompanyList: [
            { key: "1", Label: "company 1", value: "company 1" },
            { key: "2", Label: "company 2", value: "company 2" },
        ],
        ProjectList: [
            { key: "1", Label: "Project 1", value: "Project 1" },
            { key: "2", Label: "Project 2", value: "Project 2" },
        ],
        SystemsList: [
            { key: "1", Label: "System 1", value: "System 1" },
            { key: "2", Label: "System 2", value: "System 2" },
        ],
        TimeZoneList: [
            { key: "1", Label: "TimeZone 1", value: "TimeZone 1" },
            { key: "2", Label: "TimeZone 2", value: "TimeZone 2" },
        ]
    }

}
export function authReducer(state = initState, action) {
    const payload = action.payload;

    switch (action.type) {
        case GET_USER.STARTED:
            return {
                //          ...(state), // flush stored info, as if it is not authenticated
                ...state,
                user: {
                    ...state.user,
                    loading: true,
                    loadingTime: new Date()
                }
            }
        case GET_USER.SUCCEEDED:
            return {
                ...(state),
                user: {
                    ...state.user,
                    ...(action.payload),
                    loading: false,
                    key: Date.now()
                },
            }
        case GET_USER.FAILED:
            return {
                ...initState,
                user: {
                    ...(action.payload),
                    loading: false,
                }
            }
        case LOGIN.STARTED:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...(action.payload),
                    loading: true
                },
            }
        case LOGIN.SUCCEEDED:
            return {
                ...state,
                user: {
                    ...(action.payload),
                    loading: false
                },
            }
        case LOGIN.FAILED:
            return {
                ...state,
                user: {
                    ...(action.payload),
                    loading: false
                },
            }
        case LOGOUT.STARTED:
            return {
                ...state,
                user: {
                    loading: true
                },
            }
        case LOGOUT.SUCCEEDED:
        case LOGOUT.FAILED:
        case LOGOUT.ENDED:
            return {
                ...state,
                user: {
                    loading: false
                },
            }
        case UPD_PROFILE.STARTED:
            return {
                ...state,
                page_saving: true
            }
        case UPD_PROFILE.SUCCEEDED:
            return {
                ...state,
                page_saving: false,
                user: {
                    ...(action.payload)
                },
            }
        case UPD_PROFILE.FAILED:
            return {
                ...state,
                page_saving: false
            }
        case CHANGE_PASSWORD.STARTED:
            return {
                ...state,
                page_saving: true
            }
        case CHANGE_PASSWORD.SUCCEEDED:
            return {
                ...state,
                page_saving: false
            }
        case CHANGE_PASSWORD.FAILED:
            return {
                ...state,
                page_saving: false
            }
        case RESET_PASSWORD_EMAIL.STARTED:
            return {
                ...state,
                page_saving: true
            }
        case RESET_PASSWORD_EMAIL.SUCCEEDED:
            return {
                ...state,
                page_saving: false
            }
        case RESET_PASSWORD_EMAIL.FAILED:
            return {
                ...state,
                page_saving: false
            }
        case SWITCH_CURRENT.STARTED:
            return {
                ...state,
                page_saving: true
            }
        case SWITCH_CURRENT.SUCCEEDED:
            return {
                ...state,
                user: {
                    ...state.user,
                    CompanyId: payload.CompanyId,
                    ProjectId: payload.ProjectId
                },
                page_saving: false
            }
        case SWITCH_CURRENT.FAILED:
            return {
                ...state,
                page_saving: false
            }
        default:
            return state;
    }
}

// action function maker
export function ShowSpinner(state) {
    return !state || state.page_loading || state.page_saving;
}

export function login(username, password) {

    return (dispatch, getState, { webApi }) => {
        dispatchWithNotification(dispatch, { type: LOGIN.STARTED, payload: { username: username } });
        authService.login(username, password).then(
            (data) => {
                if (data.status === "success") {
                    //dispatchWithNotification(dispatch, { type: LOGIN.SUCCEEDED, payload: data.accessCode});
                    //dispatchWithNotification(dispatch, { type: GET_TOKEN.STARTED, payload: data.accessCode});
                    authService.getToken(data.accessCode).then(
                        data => {
                            //dispatchWithNotification(dispatch, { type: GET_TOKEN.SUCCEEDED, payload: data.data});
                            //dispatchWithNotification(dispatch, { type: GET_USER.STARTED, payload: data.data});
                            authService.getUsr().then(
                                data => {
                                    dispatchWithNotification(dispatch, { type: GET_USER.SUCCEEDED, payload: data.data });
                                },
                                error => {
                                    dispatchWithNotification(dispatch, { type: GET_USER.FAILED, payload: error });
                                }
                            ).catch(error => {
                                console.log(error);
                            })
                        }, error => {
                            dispatchWithNotification(dispatch, { type: GET_TOKEN.FAILED, payload: error });
                        }).catch(error => {
                            console.log(error);
                        })
                }
                else {
                    dispatchWithNotification(dispatch, { type: LOGIN.FAILED, payload: data });
                    //dispatchWithNotification(dispatch, getNotificationAction("E", data.error || data.errMsg));
                }
            },
            (error) => {
                console.log(error);
                dispatchWithNotification(dispatch, { type: LOGIN.FAILED, payload: error });
            }
        );
    };
}

export function logout() {
    return (dispatch) => {
        dispatchWithNotification(dispatch, { type: LOGOUT.STARTED, payload: {} });

        authService.logout().then(
            (result) => {
                dispatchWithNotification(dispatch, { type: LOGOUT.SUCCEEDED, payload: result })
            }
        )
            .catch(error => {
                dispatchWithNotification(dispatch, { type: LOGOUT.FAILED, payload: error });
            })
    }
}

export function getCurrentUser(silent = false) {
    return (dispatch) => {
        //if (!authService.isAuthenticated()) return;
        if (!authService.getRefreshToken().refresh_token) return;

        dispatchWithNotification(dispatch, { type: GET_USER.STARTED, payload: null });
        authService.getUsr().then(
            (data) => {
                if (data.data) {
                    dispatchWithNotification(dispatch, { type: GET_USER.SUCCEEDED, payload: data.data });
                }
                else {
                    dispatchWithNotification(dispatch, { type: GET_USER.FAILED, payload: data });
                }
            },
            (error) => {
                if (!silent) {
                    // dispatchWithNotification(dispatch, getNotificationAction("E", {
                    //     type: 'network',
                    //     message: 'network error'
                    // }));
                }
                dispatchWithNotification(dispatch, { type: GET_USER.FAILED, payload: error });
            }
        ).catch(
            error => {
                console.log(error);
                dispatchWithNotification(dispatch, { type: GET_USER.FAILED, payload: error });
            }
        );
    };
}

export function saveProfile(values) {
    return (dispatch, getState, { webApi }) => {
        dispatchWithNotification(dispatch, { type: UPD_PROFILE.STARTED, payload: { message: "Profile Update started" } });

        const { newLoginName, newUserName, newUserEmail } = values;
        
        profileService.updateProfile(newLoginName, newUserName, newUserEmail).then(
            (ret => {
                dispatchWithNotification(dispatch, { type: UPD_PROFILE.SUCCEEDED, payload: { message: "Profile Update succeeded" } });
            })
            ,
            (err => {
                dispatchWithNotification(dispatch, { type: UPD_PROFILE.FAILED, payload: { error: err, message: err.errMsg } });
            })
        );
    };
}

export function changePassword(values) {
    return (dispatch, getState, { webApi }) => {
        dispatchWithNotification(dispatch, { type: CHANGE_PASSWORD.STARTED, payload: { message: "Password changed started" } });
        
        const { j, p, newUsrPassword, confirmPwd } = values;

        profileService.updUsrPwd(j, p, newUsrPassword, confirmPwd).then(
            (ret => {
                dispatchWithNotification(dispatch, { type: CHANGE_PASSWORD.SUCCEEDED, payload: { message: "Password changed succeeded" } });
            })
            ,
            (err => {
                dispatchWithNotification(dispatch, { type: CHANGE_PASSWORD.FAILED, payload: { error: err, message: err.errMsg } });
            })
          );
    };
}

export function resetPasswordEmail(values) {
    return (dispatch, getState, { webApi }) => {
        dispatchWithNotification(dispatch, { type: RESET_PASSWORD_EMAIL.STARTED, payload: { message: "Password reset Email sent Successfully" } });

        const { resetLoginName, resetUsrEmail } = values;

        profileService.resetPwd(resetLoginName, resetUsrEmail).then(
            (ret => {
                dispatchWithNotification(dispatch, { type: RESET_PASSWORD_EMAIL.SUCCEEDED, payload: { message: "Password reset Email has been sent Successfully" } });
            })
            ,
            (err => {
                dispatchWithNotification(dispatch, { type: RESET_PASSWORD_EMAIL.FAILED, payload: { error: err, message: err.errMsg } });
            })
          );
    };
}

export function switchCurrent(companyId, projectId) {
    return (dispatch, getState, { webApi }) => {
        dispatchWithNotification(dispatch, { type: SWITCH_CURRENT.STARTED, payload: { message: "Profile Update started" } });

        systemService.switchCurrent(companyId, projectId).then(
            (ret => {
                dispatchWithNotification(dispatch, { type: SWITCH_CURRENT.SUCCEEDED, payload: ret.data });
            })
            ,
            (err => {
                dispatchWithNotification(dispatch, { type: SWITCH_CURRENT.FAILED, payload: { error: err, message: err.errMsg } });
            })
        );
    };
}



// WEBPACK FOOTER //
// ./src/redux/Auth.js